import { render, staticRenderFns } from "./AddEvaluation.vue?vue&type=template&id=e95c1318&scoped=true&"
import script from "./AddEvaluation.vue?vue&type=script&lang=js&"
export * from "./AddEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./AddEvaluation.vue?vue&type=style&index=0&id=e95c1318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95c1318",
  null
  
)

export default component.exports